import React from 'react';
import { ui } from '../../styles/ui';

export const PageHeader = ({ title, subtitle, actions }) => (
  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
    <div>
      <h1 className={ui.pageTitle}>{title}</h1>
      {subtitle && <p className={ui.pageSubtitle}>{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);
